import { TerminateTask } from './terminateTask.types'

export const createTerminateTask = ({
  name,
  taskReferenceName,
  inputParameters
}: Omit<TerminateTask, 'type'>): TerminateTask => {
  return {
    type: 'TERMINATE',
    name,
    taskReferenceName,
    inputParameters
  }
}
